import http from './http.service'

http.setToken(getToken())

async function login(payload) {
  const response = await http.post(
    process.env.REACT_APP_API_URL + '/login', payload
  )
  return response.data
}

async function register(payload) {
  const response = await http.post(
    process.env.REACT_APP_API_URL + '/register', payload
  )
  return response.data
}

async function sendOtp(payload) {
  const response = await http.post(
    process.env.REACT_APP_API_URL + '/send_verification_code', payload
  )
  return response.data
}

function logout() {
  localStorage.clear()
}

function getToken() {
  return localStorage.getItem('token')
}

const authService = {
  login,
  register,
  sendOtp,
  logout,
  getToken,
};

export default authService